module.exports = {"meta":"Links","immediate-aid-title":"","pension-title":"","advance-decision-title":""}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/links.json
// module id = QnTb
// module chunks = 1